export const USER_REPORT_COLUMNS = [
  {
    id: "user",
    label: "Username",
    width: "18%",
    isObj: true,
    child: "username",
  },
  {
    id: "reportUser",
    label: "Reporter Username",
    width: "18%",
    isObj: true,
    child: "username",
  },
  {
    id: "isParentReport",
    label: "Reporter Type",
    width: "12%",
  },
  { id: "createdAt", label: "Report Date", width: "18%", isDate: true },
  {
    id: "status",
    label: "Status",
    width: "18%",
    isObjList: true,
    list: ["Approved", "Pending", "Reject"],
    child: "label",
  },
  { id: "reason", label: "Reason", width: "25%" },
  { id: "actions", width: "25%" },
];

export enum UserReportReason {
  spam = "It’s spam",
  dislike = "I just don’t like it",
  hateSpeech = "Hate speech or symbols",
  violence = "Violence or dangerous activities",
  bullying = "Bullying or harassment",
  other = "Something else",
}

export const RADIO_Status_OPTIONS = () => [
  {
    label: "Approved",
    value: "APPROVED",
  },
  {
    label: "Rejected",
    value: "REJECTED",
  },
  {
    label: "Pending",
    value: "PENDING",
  },
];
